<template>
	<div>
		<v-card class="mt-2 pt-4 px-2" elevation="1">
			<v-form ref="formFiltro">
				<v-row no-gutters>
					<v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
						<v-text-field
							label="Mês"
							v-model="mes"
							:rules="regra.mes"
							required
							outlined
							dense
							type="month"
						></v-text-field>
					</v-col>
					<v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
						<input-id-java
							label="Filial"
							v-model="id_filial"
							:items="lista.filial"
						/>
					</v-col>
					<v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
						<SelectInput
							label="Bandeira"
							v-model="bandeira"
							:items="lista.bandeira"
							multiple
							outlined
							dense
							show-select-all
						/>
					</v-col>
					<v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
						<SelectInput
							label="Fornecedor"
							v-model="id_fornecedor"
							:items="lista.fornecedor"
							multiple
							outlined
							dense
							show-select-all
						/>
					</v-col>
					<v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
						<SelectInput
							label="Macro Fornecedor"
							v-model="id_macrofornecedor"
							:items="lista.macrofornecedores"
							multiple
							outlined
							dense
							show-select-all
						/>
					</v-col>
					<v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
						<SelectInput
							label="Espaço"
							v-model="id_espaco"
							:items="computedEspaco"
							multiple
							outlined
							dense
							show-select-all
						/>
					</v-col>
					<v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
						<SelectInput
							label="Espaço Macro"
							v-model="espaco_macro"
							:items="lista.espaco_macro"
							multiple
							outlined
							dense
							show-select-all
						/>
					</v-col>
					<v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
						<SelectInput
							label="Cluster"
							:items="lista.cluster"
							v-model="id_cluster"
							multiple
							outlined
							dense
							show-select-all
						/>
					</v-col>
					<v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
						<SelectInput
							label="Região"
							v-model="regiao"
							:items="lista.regiao"
							multiple
							outlined
							dense
							show-select-all
						/>
					</v-col>
					<v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
						<SelectInput
							label="Perfil"
							:items="lista.perfil"
							v-model="perfil"
							multiple
							outlined
							dense
							show-select-all
						/>
					</v-col>
					<v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
						<SelectInput
							label="Tamanho"
							:items="lista.tamanho"
							v-model="tamanho"
							multiple
							outlined
							dense
							show-select-all
						/>
					</v-col>
					<v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
						<SelectInput
							label="Neogrupo"
							v-model="grupo"
							:items="lista.grupo"
							multiple
							outlined
							dense
							show-select-all
						/>
					</v-col>
					<v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
						<SelectInput
							label="Master categoria"
							v-model="subgrupo"
							:items="lista.subgrupo"
							multiple
							outlined
							dense
							show-select-all
						/>
					</v-col>
					<v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
						<SelectInput
							label="Categoria"
							v-model="categoria"
							:items="lista.categoria"
							multiple
							outlined
							dense
							show-select-all
						/>
					</v-col>
					<v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
						<SelectInput
							label="Subcategoria"
							v-model="subcategoria"
							:items="lista.subcategoria"
							multiple
							outlined
							dense
							show-select-all
						/>
					</v-col>
					<v-col cols="12" sm="6" md="4" lg="3" xl="3" class="px-2">
						<!-- <v-text-field
							label="Produtos"
							outlined
							dense
							
							v-model="codigo"
						></v-text-field> -->
						<input-id-produto
							v-model="codigo"
							label="Produtos"
							:items="lista.produtos"
							
							
							
							outlined
							dense
							importacao="true"
							/>
					</v-col>
					<v-col
						cols="12"
						sm="6"
						md="4"
						lg="3"
						xl="3"
						class="px-2 ml-auto pb-2 d-flex align-center justify-end"
					>
						<v-checkbox
							class="mt-1"
							v-model="filial"
							label="Filial"
							hide-details
						></v-checkbox>
						<v-checkbox
							class="mt-1 ml-4"
							v-model="produto"
							label="Produto"
							hide-details
						></v-checkbox>
					</v-col>
					<v-col
						cols="12"
						sm="6"
						md="4"
						lg="3"
						xl="3"
						class="px-2 pb-2"
						align="end"
					>
						<v-btn class="ml-2 mb-1" color="primary" @click="limpar()">
							<v-icon left>mdi-filter-off</v-icon> Limpar
						</v-btn>
						<v-btn class="ml-2 mb-1" color="primary" @click="filtrar()">
							<v-icon left>mdi-filter</v-icon> Filtrar
						</v-btn>
					</v-col>

					<!-- <v-col cols="12" class="px-2 d-flex justify-start">
						<v-checkbox
							class="mt-0"
							v-model="vbZerado"
							label="VB zerado "
							@change="ajusteVbZerado"
						></v-checkbox>
						<v-checkbox
							class="ml-3 mt-0"
							v-model="cuboMovelDermo"
							label="Cubo+Movel Dermo "
							@change="ajusteCuboMovelDermo"
						></v-checkbox>
						<v-checkbox
							class="ml-3 mt-0"
							v-model="apenasCampanhas"
							label="Apenas Campanhas"
							@change="ajusteApenasCampanhas"
						></v-checkbox>
					</v-col> -->
				</v-row>
			</v-form>
		</v-card>
		<v-row  class="w-full">
			<v-col md="3">
				<div @click="ajusteVbZerado">
					<Indicador
						titulo="VB zerado"
						:valor="vbZerado ? vbZeradoQuantidade : ''"
						icone="mdi-numeric-0-circle"
						color="success"
						:class="{
							active: vbZerado,
						}"
					/>
				</div>
			</v-col>
			<v-col md="3">
				<div @click="ajusteCuboMovelDermo">
					<Indicador
						titulo="Cubo + Movel Dermo"
						:valor="cuboMovelDermo ? cuboMovelDermoQuantidade : ''"
						icone="mdi-cube"
						color="warning"
						:class="{
							active: cuboMovelDermo,
						}"
					/>
				</div>
			</v-col>
			<v-col md="3">
				<div @click="ajusteApenasCampanhas">
					<Indicador
						titulo="Apenas Campanhas"
						:valor="apenasCampanhas ? apenasCampanhasQuantidade : ''"
						icone="mdi-shopping"
						color="error"
						:class="{
							active: apenasCampanhas,
						}"
					/>
				</div>
			</v-col>
			<v-col md="3">
				<div @click="busqueCuboMovelDermoCampanha">
					<Indicador
						titulo="Campanhas + Cubo + Movel Dermo"
						:valor="cuboMovelDermoCampanha ? cuboMovelDermoCampanhaQuantidade : ''"
						icone="mdi-animation"
						color="error"
						:class="{
							active: cuboMovelDermoCampanha,
						}"
					/>
				</div>
			</v-col>
		</v-row>
	</div>		
</template>

<script>
import useFiltros from "../../../hooks/useFiltros";
import Indicador from "./_components/Indicador.vue";
import { mapFields } from 'vuex-map-fields'
import { mapActions } from 'vuex'
export default {
    setup() {
        const { isLoading, isError, isFetching, lista, error, refetch } =
            useFiltros("/gerencial/filtros");

        return { isLoading, isError, isFetching, lista, error, refetch };
    },
	data() {
		return {
			// lista: {},
			// cuboMovelDermo: false,
			//filtro: {},
			regra: {
				mes: [(v) => !!v || "O campo mes é obrigatório"],
			},
			// items: [],
			buscaProduto: null,
			itemsLimit: 60, 
			entries: [],
			isLoading: false,
		};
	},
    computed: {
		...mapFields('relatorio_vb',[
			'filtro.mes',
			'filtro.vbZerado',
			'filtro.apenasCampanhas',
			'filtro.cuboMovelDermoCampanha',
			'filtro.bandeira',
			'filtro.id_espaco',
			'filtro.espaco_macro',
			'filtro.id_fornecedor',
			'filtro.id_macrofornecedor',
			'filtro.id_cluster',
			'filtro.id_filial',
			'filtro.codigo',
			'filtro.regiao',
			'filtro.perfil',
			'filtro.tamanho',
			'filtro.grupo',
			'filtro.subgrupo',
			'filtro.categoria',
			'filtro.subcategoria',
			'filtro.cuboMovelDermo',
			'filtro.vbZeradoQuantidade',
            'filtro.cuboMovelDermoQuantidade',
            'filtro.apenasCampanhasQuantidade',
			'filtro.cuboMovelDermoCampanhaQuantidade',
			'filtro.filial',
			'filtro.produto'
		]),		
        overlay() {
            return Object.keys(this.lista).length === 0 && this.isFetching;
        },
		computedEspaco() {
            if(!this.lista.espaco || !this.lista.espacoSomenteLeitura) return [];
            return [...this.lista.espaco, ...this.lista.espacoSomenteLeitura].sort(function (a, b) {
                return a.text.localeCompare(b.text);
            });
        },
		
    },	
	
	components: {
		Indicador
	},
	// Filial e Produto sao granularidades de exportacao excludentes;
	// os dois desmarcados e o default, por loja e produto.
	watch: {
		filial(valor) {
			if (valor) this.produto = false;
		},
		produto(valor) {
			if (valor) this.filial = false;
		},
	},
	methods: {
		...mapActions('relatorio_vb',['iniciaFiltro','busqueDados']),
		busqueCuboMovelDermoCampanha() {
			if (!this.validate()) return;
			this.vbZerado = false
			this.cuboMovelDermo = false
			this.apenasCampanhas = false
			this.cuboMovelDermoCampanha = true
			// this.busqueDados();			
		},
		ajusteApenasCampanhas() {
			if (!this.validate()) return;
			this.vbZerado = false
			this.espaco_macro = []
			this.cuboMovelDermo = false
			this.apenasCampanhas = true
			this.cuboMovelDermoCampanha = false
			// this.busqueDados();
		},
		ajusteVbZerado () {
			if (!this.validate()) return;
			this.vbZerado = true
			this.cuboMovelDermo = false
			this.apenasCampanhas = false
			this.cuboMovelDermoCampanha = false
			// this.busqueDados();
		},	
		ajusteCuboMovelDermo (v) {
			if (!this.validate()) return;
			if (v) {
				this.espaco_macro = ['Cubo','Móvel Dermo']
			} 
			this.vbZerado = false
			this.cuboMovelDermo = true
			this.apenasCampanhas = false
			this.cuboMovelDermoCampanha = false
			// this.busqueDados();
		},
		limpar() {
			this.iniciaFiltro();
		},
		filtrar() {
			console.log(this.cuboMovelDermo)
			if (this.cuboMovelDermo) this.ajusteCuboMovelDermo (true)
			if (!this.validate()) return;
			this.$emit("filtrar");
		},
		validate() {
			return this.$refs.formFiltro.validate();
		},
		resetValidation() {
			try {
				this.$refs.formFiltro.resetValidation();
			} catch (error) {
				//console.log(error)
			}
		},
	},
};
</script>
